import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=3b772538&"
import script from "./AlertCard.vue?vue&type=script&lang=js&"
export * from "./AlertCard.vue?vue&type=script&lang=js&"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=3b772538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports